<table-revenue [paginator]="true" [showFilter]="true" [filter]="filter"></table-revenue>
